import {management} from '../../../../index'
import {LogSectorRepository} from '../../../infra/knex/repositories/log_sector'

import {DeleteLogSectorById} from './deleteLogSectorById'

export const deleteLogSectorByIdUseCase=()=>{
    const repository= new LogSectorRepository(management)

    const deleteByFkSector= new DeleteLogSectorById(repository)
    return deleteByFkSector
}
